export interface SuburbFaq {
  q: string;
  a: string;
}

export interface Suburb {
  slug: string;
  name: string;
  kind: "residential" | "commercial";
  metaTitle: string;
  metaDescription: string;
  subtitle: string;
  overview: string[];
  faqs: SuburbFaq[];
}

export const suburbs: Suburb[] = [
  {
    slug: "craigieburn",
    name: "Craigieburn",
    kind: "residential",
    metaTitle: "Rubbish Removal Craigieburn | OZ WASTE CO.",
    metaDescription:
      "Fast rubbish removal in Craigieburn. Household junk, furniture, garage and move-out clear-outs, we do the lifting and loading. Get a free upfront quote.",
    subtitle:
      "Fast rubbish removal in Craigieburn. We do the lifting, loading and removal, you just show us what needs to go.",
    overview: [
      "OZ WASTE CO. services Craigieburn and the surrounding northern suburbs, helping households clear out junk, old furniture, appliances and general clutter without the skip bin hassle.",
      "From single-item pickups in new estates to full garage and property clear-outs, our local crew loads everything from wherever it sits and takes it away in one visit.",
      "Every Craigieburn job comes with an upfront quote, send us a few photos and you'll know the agreed price before we start.",
    ],
    faqs: [
      { q: "Do you service all of Craigieburn?", a: "Yes, we cover Craigieburn and nearby northern suburbs including Roxburgh Park, Greenvale and Mickleham." },
      { q: "How much does rubbish removal cost in Craigieburn?", a: "Pricing depends on the volume and type of rubbish. Send a few photos or a quick description and we'll confirm an upfront quote before we start." },
      { q: "Do I need to move items to the kerb?", a: "No. Our crew does all the lifting and loading from inside the house, the garage or the backyard." },
      { q: "Can you clear out a garage or shed?", a: "Absolutely, garage and shed clear-outs are one of our most common Craigieburn jobs, from a few items to a full clear." },
      { q: "Do you offer same-day pickup in Craigieburn?", a: "Often, yes. Same-day and short-notice pickups may be available depending on the day's schedule, get in touch early for the best chance." },
    ],
  },
  {
    slug: "broadmeadows",
    name: "Broadmeadows",
    kind: "residential",
    metaTitle: "Rubbish Removal Broadmeadows | OZ WASTE CO.",
    metaDescription:
      "Fast rubbish removal in Broadmeadows. Household junk, furniture and move-out clear-outs, we do the lifting and loading. Get a free upfront quote.",
    subtitle:
      "Fast rubbish removal in Broadmeadows. We do the lifting, loading and removal, you just show us what needs to go.",
    overview: [
      "OZ WASTE CO. works right across Broadmeadows, clearing household junk, old furniture, mattresses and general clutter from homes, units and townhouses.",
      "Whether it's an end-of-lease clear-out, a deceased estate or just years of accumulated garage clutter, our crew handles all the lifting and loading for you.",
      "Every Broadmeadows job comes with an upfront quote, no surprises, and we leave the area clean when we're done.",
    ],
    faqs: [
      { q: "Do you service Broadmeadows and surrounds?", a: "Yes, we cover Broadmeadows plus Glenroy, Jacana, Dallas and Coolaroo." },
      { q: "How much does rubbish removal cost in Broadmeadows?", a: "Pricing depends on the volume and type of rubbish. Send a few photos and we'll confirm an upfront quote before we start." },
      { q: "Can you do end-of-lease clear-outs?", a: "Yes, move-out and end-of-lease clear-outs are a regular job for us in Broadmeadows. We clear the property so it's ready for inspection." },
      { q: "Do I need to move items outside first?", a: "No. Our crew does all the lifting and loading from wherever the items are." },
      { q: "What items do you take?", a: "Most household items: furniture, appliances, mattresses, boxes, green waste and general junk. Some hazardous items are excluded, just ask us." },
    ],
  },
  {
    slug: "roxburgh-park",
    name: "Roxburgh Park",
    kind: "residential",
    metaTitle: "Rubbish Removal Roxburgh Park | OZ WASTE CO.",
    metaDescription:
      "Fast rubbish removal in Roxburgh Park. Household junk, furniture, garage clear-outs and more, we do the lifting and loading. Free upfront quote.",
    subtitle:
      "Fast rubbish removal in Roxburgh Park. We do the lifting, loading and removal, you just show us what needs to go.",
    overview: [
      "OZ WASTE CO. services Roxburgh Park homes with fast, friendly rubbish removal, from single bulky items to full house and garage clear-outs.",
      "Growing families accumulate stuff fast. When the garage, spare room or backyard starts overflowing, our crew arrives, loads everything and takes it away in one visit.",
      "Every Roxburgh Park job comes with an upfront quote and a local crew that treats your property with care.",
    ],
    faqs: [
      { q: "Do you service Roxburgh Park?", a: "Yes, we cover Roxburgh Park and nearby suburbs including Craigieburn, Greenvale, Meadow Heights and Somerton." },
      { q: "How much does rubbish removal cost in Roxburgh Park?", a: "Pricing depends on the volume and type of rubbish. Send us a few photos and we'll confirm an upfront quote before we start." },
      { q: "Can you take large furniture like sofas and wardrobes?", a: "Yes, furniture removal is one of our most common jobs. We carry items out from wherever they are in the house." },
      { q: "Do you take green waste?", a: "Yes, we take green waste along with general household junk, furniture and appliances." },
      { q: "Do you offer same-day pickup?", a: "Often, yes, same-day and short-notice pickups may be available depending on the schedule. Get in touch early for the best chance." },
    ],
  },
  {
    slug: "glenroy",
    name: "Glenroy",
    kind: "residential",
    metaTitle: "Rubbish Removal Glenroy | OZ WASTE CO.",
    metaDescription:
      "Fast rubbish removal in Glenroy. Household junk, furniture and unit clear-outs, we do the lifting and loading. Get a free upfront quote today.",
    subtitle:
      "Fast rubbish removal in Glenroy. We do the lifting, loading and removal, you just show us what needs to go.",
    overview: [
      "OZ WASTE CO. services Glenroy's homes, units and townhouses with fast rubbish removal, no skip bin on the nature strip, no heavy lifting on your end.",
      "From unit clear-outs and old furniture to renovation leftovers and garage clutter, our local crew loads everything from wherever it sits.",
      "Every Glenroy job comes with an upfront quote, you know the agreed price before we start, and we leave the area tidy.",
    ],
    faqs: [
      { q: "Do you service Glenroy?", a: "Yes, we cover Glenroy plus Oak Park, Hadfield, Pascoe Vale and Broadmeadows." },
      { q: "Can you clear out a unit or apartment?", a: "Yes, we regularly clear units and apartments in Glenroy, including stairs and tight access. We do all the carrying." },
      { q: "How much does rubbish removal cost in Glenroy?", a: "Pricing depends on the volume and type of rubbish. Send a few photos and we'll confirm an upfront quote before we start." },
      { q: "Do you take mattresses and whitegoods?", a: "Yes, mattresses, fridges, washing machines and other whitegoods are all fine." },
      { q: "How is this different from hiring a skip?", a: "With a skip you do the loading and pay for the whole bin. With us, we load everything for you and you only pay for the space your rubbish takes up." },
    ],
  },
  {
    slug: "coburg",
    name: "Coburg",
    kind: "residential",
    metaTitle: "Rubbish Removal Coburg | OZ WASTE CO.",
    metaDescription:
      "Fast rubbish removal in Coburg. Household junk, furniture, garage and move-out clear-outs, we do the lifting and loading. Free upfront quote.",
    subtitle:
      "Fast rubbish removal in Coburg. We do the lifting, loading and removal, you just show us what needs to go.",
    overview: [
      "OZ WASTE CO. works across Coburg, clearing household junk, old furniture and accumulated clutter from period homes, units and new builds alike.",
      "Renovating, moving out or just reclaiming the garage? Our crew loads everything for you and takes it away in one visit, no skip permits, no waiting days for pickup.",
      "Every Coburg job comes with an upfront quote and responsible disposal, with reusable and recyclable items diverted from landfill where possible.",
    ],
    faqs: [
      { q: "Do you service Coburg?", a: "Yes, we cover Coburg plus Coburg North, Preston, Brunswick and Pascoe Vale." },
      { q: "How much does rubbish removal cost in Coburg?", a: "Pricing depends on the volume and type of rubbish. Send us a few photos and we'll confirm an upfront quote before we start." },
      { q: "Can you remove renovation or building waste?", a: "We take general renovation leftovers like packaging, old fixtures and timber offcuts. Some materials are excluded, send photos and we'll confirm." },
      { q: "Do I need to be home for the pickup?", a: "Ideally yes, so we can confirm the items and price on arrival. If everything is clearly accessible, we can discuss contactless options." },
      { q: "Are you insured?", a: "Yes. Public liability cover applies to every job, so your property is protected while we work." },
    ],
  },
  {
    slug: "somerton",
    name: "Somerton",
    kind: "commercial",
    metaTitle: "Commercial Rubbish Removal Somerton | OZ WASTE CO.",
    metaDescription:
      "Commercial and industrial rubbish removal in Somerton. Warehouse, office and factory clear-outs, upfront quotes, fast pickup. OZ WASTE CO.",
    subtitle:
      "Fast commercial rubbish removal in Somerton. Warehouses, offices and factories, we do the lifting, loading and removal.",
    overview: [
      "OZ WASTE CO. services Somerton's industrial and commercial precinct with fast rubbish removal for warehouses, factories, offices and retail spaces.",
      "From old racking and pallets to office fit-out strip-outs and end-of-lease clear-outs, our crew loads everything and clears the site efficiently so your business keeps moving.",
      "Every Somerton job comes with an upfront written quote and pickup windows that work around your operating hours.",
    ],
    faqs: [
      { q: "Do you service Somerton's industrial area?", a: "Yes, we work across Somerton's industrial precinct and nearby Campbellfield, Roxburgh Park and Coolaroo." },
      { q: "Can you clear out a warehouse?", a: "Yes, warehouse clear-outs are a core service in Somerton. We remove old stock, packaging, racking, pallets and general waste." },
      { q: "Do you do office strip-outs?", a: "Yes, we remove office furniture, workstations, e-waste and fit-out waste. Some materials are excluded; send photos and we'll confirm." },
      { q: "How much does commercial rubbish removal cost in Somerton?", a: "Pricing depends on the volume and type of waste. Send photos or a description and we'll confirm an upfront quote before we start." },
      { q: "Can you work around our operating hours?", a: "Yes, we schedule pickups to minimise disruption, including early morning and off-peak windows where possible." },
    ],
  },
  {
    slug: "campbellfield",
    name: "Campbellfield",
    kind: "commercial",
    metaTitle: "Commercial Rubbish Removal Campbellfield | OZ WASTE CO.",
    metaDescription:
      "Commercial and industrial rubbish removal in Campbellfield. Warehouse, factory and office clear-outs, upfront quotes, fast pickup. OZ WASTE CO.",
    subtitle:
      "Fast commercial rubbish removal in Campbellfield. Warehouses, factories and offices, we do the lifting, loading and removal.",
    overview: [
      "OZ WASTE CO. is local to Campbellfield and services its industrial precinct with fast, reliable rubbish removal for warehouses, factories and offices.",
      "Whether it's an end-of-lease warehouse clear-out, old machinery surrounds, pallets and packaging, or an office fit-out strip-out, our crew handles all the loading.",
      "Every Campbellfield job comes with an upfront quote, you'll know the agreed price before we start, and we leave the site clean.",
    ],
    faqs: [
      { q: "Do you service Campbellfield?", a: "Yes, Campbellfield is one of our home areas. We also cover Somerton, Broadmeadows, Fawkner and Coburg North." },
      { q: "Can you clear out a factory or warehouse?", a: "Yes, we clear warehouses and factories of old stock, packaging, pallets, racking and general waste, from partial clear-outs to full end-of-lease jobs." },
      { q: "Do you take pallets and packaging waste?", a: "Yes, pallets, cardboard, shrink wrap and general packaging waste are common Campbellfield pickups for us." },
      { q: "How much does commercial rubbish removal cost in Campbellfield?", a: "Pricing depends on the volume and type of waste. Send a few photos and we'll confirm an upfront quote before we start." },
      { q: "Do you offer same-day commercial pickups?", a: "Often, yes, being local to the area means same-day and short-notice pickups are frequently available. Get in touch early for the best chance." },
    ],
  },
  {
    slug: "tullamarine",
    name: "Tullamarine",
    kind: "commercial",
    metaTitle: "Commercial Rubbish Removal Tullamarine | OZ WASTE CO.",
    metaDescription:
      "Commercial and industrial rubbish removal in Tullamarine. Warehouse, office and business clear-outs, upfront quotes, fast pickup. OZ WASTE CO.",
    subtitle:
      "Fast commercial rubbish removal in Tullamarine. Warehouses, offices and business premises, we do the lifting, loading and removal.",
    overview: [
      "OZ WASTE CO. services Tullamarine's business and industrial areas with fast rubbish removal for warehouses, offices, logistics sites and retail premises.",
      "From office furniture and e-waste to packaging, pallets and end-of-lease clear-outs, our crew loads everything and clears the site with minimal disruption.",
      "Every Tullamarine job comes with an upfront quote and pickup windows scheduled around your operating hours.",
    ],
    faqs: [
      { q: "Do you service Tullamarine?", a: "Yes, we cover Tullamarine and nearby Airport West, Gladstone Park, Westmeadows and Melbourne Airport precinct businesses." },
      { q: "Can you clear an office or warehouse?", a: "Yes, we clear office furniture, workstations, e-waste, old stock, packaging and general commercial waste." },
      { q: "Do you handle end-of-lease commercial clear-outs?", a: "Yes, we clear the premises so it's ready for handover, loading everything from wherever it sits on site." },
      { q: "How much does commercial rubbish removal cost in Tullamarine?", a: "Pricing depends on the volume and type of waste. Send photos or a description and we'll confirm an upfront quote before we start." },
      { q: "Can you work outside business hours?", a: "Yes, we can schedule early morning or off-peak pickups to minimise disruption to your operations." },
    ],
  },
  {
    slug: "coburg-north",
    name: "Coburg North",
    kind: "commercial",
    metaTitle: "Rubbish Removal Coburg North | OZ WASTE CO.",
    metaDescription:
      "Commercial and residential rubbish removal in Coburg North. Warehouse, factory and household clear-outs, upfront quotes, fast pickup. OZ WASTE CO.",
    subtitle:
      "Fast rubbish removal in Coburg North. Industrial sites, offices and homes, we do the lifting, loading and removal.",
    overview: [
      "OZ WASTE CO. services Coburg North's mix of industrial estates, businesses and homes with fast rubbish removal, commercial clear-outs and household jobs alike.",
      "From warehouse and factory clear-outs along the industrial strips to garage and household clear-outs in the residential pockets, our crew does all the lifting and loading.",
      "Every Coburg North job comes with an upfront quote, send a few photos and you'll know the agreed price before we start.",
    ],
    faqs: [
      { q: "Do you service Coburg North?", a: "Yes, we cover Coburg North plus Coburg, Hadfield, Fawkner and Campbellfield." },
      { q: "Do you do commercial and industrial clear-outs?", a: "Yes, warehouse, factory and office clear-outs are a core service in Coburg North, along with household rubbish removal." },
      { q: "How much does rubbish removal cost in Coburg North?", a: "Pricing depends on the volume and type of waste. Send a few photos and we'll confirm an upfront quote before we start." },
      { q: "Do you take pallets, packaging and old stock?", a: "Yes, pallets, cardboard, packaging and general commercial waste are all fine. Some materials are excluded; send photos and we'll confirm." },
      { q: "Can you work around business hours?", a: "Yes, we schedule pickups to minimise disruption, including early morning and off-peak windows where possible." },
    ],
  },
];

export const getSuburb = (slug: string) => suburbs.find((s) => s.slug === slug);
